import { Directive, ElementRef, inject, input } from '@angular/core';

// eslint-disable-next-line boundaries/element-types
import { injectWalkthroughRegister } from '@core/walkthrough-contracts';
import {
  RendererCallbackFn,
  WalkthroughStepId,
  WalkthroughStepOrigin,
  WalkthroughStepOriginConditional,
} from '@core/walkthrough-types';

@Directive({ selector: '[rtWalkthroughOriginStepId]', standalone: true })
export class WalkthroughStepOriginDirective implements WalkthroughStepOriginConditional {
  private readonly walkthroughStepsService = injectWalkthroughRegister();

  public readonly elementRef = inject(ElementRef);

  public readonly rtWalkthroughOriginStepId = input<WalkthroughStepId | undefined>();

  public readonly afterDisposeCallback = input<RendererCallbackFn | undefined>(undefined, {
    alias: 'rtWalkthroughOriginAfterDispose',
  });

  public readonly beforeRenderCallback = input<RendererCallbackFn | undefined>(undefined, {
    alias: 'rtWalkthroughOriginBeforeRender',
  });

  public readonly cleanupCallback = input<RendererCallbackFn | undefined>(undefined, {
    alias: 'rtWalkthroughOriginCleanup',
  });

  public ngOnInit(): void {
    const rtWalkthroughOriginStepId = this.rtWalkthroughOriginStepId();
    if (rtWalkthroughOriginStepId) {
      this.walkthroughStepsService.register(rtWalkthroughOriginStepId, <WalkthroughStepOrigin>this);
    }
  }

  public ngOnDestroy(): void {
    const rtWalkthroughOriginStepId = this.rtWalkthroughOriginStepId();
    if (rtWalkthroughOriginStepId) {
      this.walkthroughStepsService.unregister(rtWalkthroughOriginStepId);
    }
  }
}
